// extracted by mini-css-extract-plugin
export default {"goBackLink":"style--goBackLink--4349e5"};